import { LucideIcon, LucideProps } from "lucide-react";
import { FC } from "react";

type IconProps = LucideProps & {
    icon: LucideIcon;
    className?: string;
};

const Icon: FC<IconProps> = ({ icon: IconComponent, className = "", ...props }) => {
    return <IconComponent className={className} {...props} />;
};

export default Icon;
